import { initWebPush } from "./redux/webPush";
import { loadAds } from "./loadAds";
import { hasRussianTimezone } from "./util/timezone";

export function idleLoadScripts(currentPath: string, gamePath: boolean) {
  setTimeout(() => idleLoad(currentPath, gamePath), 2000);
}

let hasRun = false;
async function idleLoad(currentPath: string, gamePath: boolean) {
  if (hasRun) return;
  hasRun = true;

  if (process.env.NODE_ENV == "production") {
    const isRussia = await hasRussianTimezone();
    if (currentPath.startsWith("/lobby") || gamePath) {
      loadAds(isRussia);
    }

    consentListener();
    // growthbookExperiments();
    initWebPush();
  }
}

export function consentListener() {
  window.googlefc = window.googlefc || {};
  window.googlefc.callbackQueue = window.googlefc.callbackQueue || [];
  window.googlefc.callbackQueue.push({
    CONSENT_DATA_READY: () =>
      window.__tcfapi("addEventListener", 2.2, (data, success) => {
        if (success) {
          updateGAConsent(data.purpose.consents);
        }
      }),
  });
}

// Function to update Google Analytics consent settings
function updateGAConsent(purposeConsents) {
  const consentData = {
    analytics_storage: purposeConsents[1] ? "granted" : "denied",
    ad_storage: purposeConsents[2] ? "granted" : "denied",
    ad_personalization: purposeConsents[4] ? "granted" : "denied",
    ad_user_data: purposeConsents[7] ? "granted" : "denied",
  };
  window.gtag("consent", "update", consentData);
}
